import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { RegbpService } from '../api/src/app/services/regbp.service';
import { concatAll, map, toArray } from 'rxjs/operators';
import { CourtLocation } from '../api/src/app/models/REGBP-V1.0.0/court-location.model';
import { CourtLocationList } from '../api/src/app/models/REGBP-V1.0.0/responses/court-location-list.model';

@Injectable({
  providedIn: 'root'
})
export class CourtlocationFacade {
  constructor(public regbpService: RegbpService) {}

  public getCourtlocations(zipcode: string, landcode: string, language: string): Observable<CourtLocation[]> {
    return this.regbpService.getCourtLocationList(zipcode, landcode, language).pipe(
      map((results: any) => results.$response.body.values),
      concatAll(),
      map((courtLocation: CourtLocation) => {
        return courtLocation;
      }),
      toArray()
    );
  }

  public getCourtLocationsNGI(countryCode: string, bestAddressId?: string, zipcode?: string): Observable<CourtLocation[]>{
    return this.regbpService.getCourtLocationsNGIV2(countryCode, bestAddressId, zipcode).pipe(
      map((result: CourtLocationList) => {
        //Get distinctValues on the ngiCantoncode key, to prevent doubles
        //No more need for distinct sorting JP takes care of it in Back
        //return [...new Map(result.values?.map((item: CourtLocation) => [item.ngiCantonCode, item])).values()] as Array<CourtLocation>;
        return result.values;
      }
    ));
  }
}
